import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import Pagination from "./../../components/Pagination";
import SortList from "../../../src/components/sortlist/SortList";
import { Link } from "react-router-dom";
import ViewFleet from "./ViewFleet";
import { useDispatch, useSelector } from "react-redux";
import {
  fleetList,
  fleetDelete,
  multiFleetDelete,
} from "../../redux/action/fleet";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import { APIURL } from "../../redux/action/config";
import search from "../../utils/search";
import { CSVLink } from "react-csv";
import TableStatusRow from "../../components/loader/TableStatusRow";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
const FleetList = ({ pageLoading, fleetListData, not_found }) => {
  const [productDataList, setProductDataList] = useState([]);
  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };
  const [viewDetails, setViewDetails] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const loadList = async () => {
    setLoading(true);
    try {
      await dispatch(fleetList());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadList();
  }, [dispatch]);

  const fleetDel = async (id) => {
    const res = await dispatch(fleetDelete(id));
    if (res?.success) {
      setProductDataList(productDataList.filter((f) => f._id != id));
    }
    setTimeout(() => {
      loadList();
    }, 1000);
  };

  const getBadge = (status) => {
    switch (status) {
      case "available":
        return "success";
      case "busy":
        return "warning";
      case "out_of_service":
        return "secondary";
      default:
        return "primary";
    }
  };
  const headers = [
    { label: "_id", key: "id" },
    { label: "Fleet Name", key: "name" },
    { label: "Model", key: "model" },
    { label: "Fuel Type", key: "fuel" },
    { label: "Status", key: "status" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];
  // const data = productDataList
  //   ? productDataList?.map((item) => {
  //       return {
  //         id: item?._id,
  //         name: item?.name,
  //         model: item?.vehicle_model,
  //         fuel: item?.fuel_type,
  //         status: item?.status,
  //         created: item?.createdAt,
  //         updated: item?.updatedAt,
  //       };
  //     })
  //   : "";
  // ********** All Select Delete **********
  const [btnStatus, setBtnStatus] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(productDataList);
  }, [productDataList]);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };

  const handleAllDelete = () => {
    multiFleetDelete(isCheck);
    setTimeout(() => {
      loadList();
      setIsCheckAll(false);
      setIsCheck([]);
    }, 1000);
  };
  const handleGetId = (e, id) => {
    e?.preventDefault();
    if (!id) return;
    setViewDetails("");
    const token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/fleets/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setViewDetails(result?.data?.fleet);
      })
      .catch((error) => console.log("error", error));
  };

  const FleetData = fleetListData?.data?.fleet
    ? fleetListData?.data?.fleet
    : "";

  // Download csv files - export the selected rows, or the whole visible list if nothing is checked
  const seledCsvList =
    isCheck?.length > 0
      ? productDataList?.filter((item) => isCheck?.includes(item?.id))
      : productDataList;

  const data = seledCsvList
    ? seledCsvList?.map((item) => {
        return {
          id: item?._id,
          name: item?.name,
          model: item?.vehicle_model,
          fuel: item?.fuel_type,
          status: item?.status,
          created: item?.createdAt,
          updated: item?.updatedAt,
        };
      })
    : "";

  // pdf code start
  const downloadPDF = () => {
    const capture = document.querySelector(".table");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };
  // pdf code end

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />

      <Layout title="Fleets List" page="fleet">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row pt-4 pb-4">
              <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                <div
                  className="dataTables_length"
                  id="kt_datatable_example_5_length"
                >
                  {isCheck && isCheck?.length > 0 ? (
                    <button
                      onClick={() => {
                        handleAllDelete();
                      }}
                      className="delete-selected"
                    >
                      Delete Selected
                    </button>
                  ) : (
                    ""
                  )}
                  {/* <label>
                    Show
                    <select
                      name="kt_datatable_example_5_length"
                      aria-controls="kt_datatable_example_5"
                      className="form-select form-select-sm form-select-solid"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label> */}
                </div>
              </div>
              <div className="col-sm-6 d-flex align-items-center justify-content-end">
                <div
                  id="kt_datatable_example_5_filter"
                  className="dataTables_filter"
                >
                  <label>
                    Search:
                    <input
                      type="search"
                      onChange={() => {
                        search();
                      }}
                      id="myInput"
                      className="form-control form-control-sm form-control-solid"
                      placeholder=""
                      aria-controls="kt_datatable_example_5"
                    />
                  </label>
                </div>
                <div className="ms-3">
                  <a
                    className="btn pgf btn-secondary dropdown-toggle"
                    href="#"
                    // role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    // className="csvlink"
                    style={{ background: "none" }}
                  >
                    Download File
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item">
                        <CSVLink
                          style={{ color: "#000" }}
                          data={data}
                          headers={headers}
                        >
                          Download as CSV
                        </CSVLink>
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" onClick={downloadPDF}>
                        Download as PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row g-5 g-xxl-10">
              <div className="col-xl-12 col-xxl-12 mb-5 mb-xxl-12">
                <div
                  id="kt_datatable_example_5_wrapper"
                  className="dataTables_wrapper dt-bootstrap4 no-footer"
                >
                  <div className="table-responsive table-wrapper">
                    <table
                      id="kt_datatable_example_5"
                      className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                    >
                      <thead>
                        <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                          <th style={{ padding: "16px 0px 16px 24px" }}>
                            <input
                              type="checkbox"
                              name="selectAll"
                              id="selectAll"
                              onClick={() => {
                                handleSelectAll();
                                setBtnStatus(true);
                              }}
                              checked={isCheckAll}
                              className="form-check-input custum-check"
                            />
                          </th>
                          <th style={{ width: "139.781px" }}>Fleet Name</th>
                          <th style={{ width: "127.297px" }}>Model</th>
                          {/* {<th style={{ width: "65.0469px" }}>Year</th> } */}
                          {/* { <th style={{ width: "75.5625px" }}>Color</th> } */}
                          {/* <th style={{ width: "176.344px" }}>
                            Registration Number
                          </th> */}
                          {/* { <th style={{ width: "155.438px" }}>License Plate</th> } */}
                          <th style={{ width: "117.438px" }}>Fuel Type</th>
                          <th style={{ width: "75.438px" }}>Status</th>
                          <th style={{ width: "227.344px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ||
                        (!productDataList?.length && FleetData?.length) ? (
                          <TableStatusRow loading colSpan={6} />
                        ) : productDataList?.length ? (
                          productDataList?.map((item, index) => {
                            return (
                              <tr key={index} className="pro-list-info">
                                <td
                                  style={{ width: "20px" }}
                                  className="check-list"
                                >
                                  <input
                                    type="checkbox"
                                    name={item?.firstName}
                                    id={item?.id}
                                    onClick={(e) => handleClick(e)}
                                    checked={isCheck.includes(item?.id)}
                                    className="form-check-input custum-check"
                                  />
                                </td>
                                <td>{item.name}</td>
                                <td>{item.vehicle_model}</td>
                                <td>{item.fuel_type}</td>
                                <td>
                                  <span
                                    className={`btn ${getBadge(item.status)}`}
                                  >
                                    {item.status === "available"
                                      ? "Available"
                                      : item.status === "busy"
                                      ? "Busy"
                                      : item.status === "out_of_service"
                                      ? "Out of Service"
                                      : ""}
                                  </span>
                                </td>
                                <td>
                                  <a
                                    type="button"
                                    onClick={(e) => handleGetId(e, item?._id)}
                                    className="btn btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#fleetDetailModal"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-eye-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                      <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                                    </svg>
                                  </a>
                                  <ViewFleet
                                    modalId={"fleetDetailModal"}
                                    viewDetails={viewDetails ? viewDetails : ""}
                                  />
                                  <Link
                                    to={`/edit-fleet/${item.id}`}
                                    className="btn btn-info action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil-square"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                      <path
                                        fillRule="evenodd"
                                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                      />
                                    </svg>
                                  </Link>
                                  <Link
                                    to="/manage-fleet"
                                    onClick={() => fleetDel(item.id)}
                                    className="btn btn-bg-dark action-hover"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-trash-fill"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                    </svg>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <TableStatusRow colSpan={6} message="Data not found" />
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    pageSize={10}
                    items={FleetData}
                    onChangePage={onChangePage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.fleet?.loading,
  fleetListData: state?.fleet?.list,
  not_found: state?.fleet?.not_found,
});

export default connect(mapStateToProps, { fleetList })(FleetList);
